<template>
  <v-form class="px-2" v-model="valid" ref="contestantsForm">
    <v-layout row wrap class="align-baseline">
      <v-flex grow>
        <h3 class="display-1 font-weight-bold">Add Contestants</h3>
      </v-flex>
      <v-flex shrink>
        <v-checkbox
            v-model="hasProbability"
            label="Probability"
            class="mt-2 mx-2"
        ></v-checkbox>
      </v-flex>
    </v-layout>
    <v-alert :value="limits.type && !limits.played" type="warning" outline style="border-radius: 0.5rem;">
      {{limits.typeMessage}}
    </v-alert>
    <v-alert :value="limits.played" type="warning" outline style="border-radius: 0.5rem;">
      {{limits.playedMessage}}
    </v-alert>
    <v-layout row wrap>
      <v-flex xs12 sm6 md3 v-if="!limits.played">
        <contestants-card add @add-card="addCard" :has-probability="hasProbability" ></contestants-card>
      </v-flex>
      <v-flex v-for="(card, i) in $store.state.instaplayForm.contestants.cards" :key="i" xs12 sm6 md3>
        <contestants-card
            :obj="card"
            :has-probability="hasProbability"
            :show-actions="!limits.played"
            @delete="deleteCard(i)"
            @edit="(obj) => {wrapEdit(obj, i)}"
        ></contestants-card>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-spacer></v-spacer>
      <v-btn round color="warning" @click="submit" :disabled="!valid">next</v-btn>
    </v-layout>
  </v-form>
</template>

<script>
    import ContestantsCard from "@/components/ContestantsCard";
    import {mapMutations, mapState} from "vuex";
    import {mapGetters} from "vuex";

    export default {
        name: "Contestants",
        components: {ContestantsCard},
        data() {
            return {
                hasProbability: true
            }
        },
        methods: {
            ...mapMutations('instaplayForm/contestants', ['addCard', 'deleteCard', 'editCard']),
            submit: function () {
                this.$emit('setState', 3)
                //submit the form...
            },
            wrapEdit: function (obj, i) {
                obj.i = i
                this.editCard(obj)
            }
        },
        computed: {
            ...mapGetters('instaplayForm/contestants', ['numberOfCards']),
            ...mapState('instaplayForm', ['limits']),
            valid: {
                get() {
                    return !!this.numberOfCards
                },
                set(newValue) {
                    return newValue
                }

            }
        },
        watch: {
            valid: function (val) {
                this.$emit('input', val)
            }
        }
    }
</script>

<style scoped>

</style>
